var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExcel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3553 2.30762H12.3076V4.603H14.6392V6.16531H12.3076V7.69223H14.6153V9.23069H12.3076V10.7692H14.6153V12.3076H12.3076V13.8461H14.6153V15.3845H12.3076V17.6922H19.3553C19.7099 17.6922 19.9999 17.3915 19.9999 17.023V2.97685C19.9999 2.60839 19.7099 2.30762 19.3553 2.30762ZM18.4615 15.3845H15.3845V13.8461H18.4615V15.3845ZM18.4615 12.3076H15.3845V10.7692H18.4615V12.3076ZM18.4615 9.23069H15.3845V7.69223H18.4615V9.23069ZM18.4615 6.15377H15.3845V4.61531H18.4615V6.15377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.22231V17.7785L11.5385 20V0L0 2.22231ZM7.29846 13.9077L5.95615 11.37C5.90538 11.2754 5.85308 11.1015 5.79846 10.8485H5.77769C5.75231 10.9677 5.69231 11.1492 5.59769 11.3923L4.25077 13.9077H2.15923L4.64231 10.0123L2.37077 6.11615H4.50615L5.62 8.45231C5.70692 8.63692 5.78462 8.85615 5.85385 9.10923H5.87538C5.91923 8.95692 6.00077 8.73077 6.12 8.43L7.35846 6.11538H9.31385L6.97769 9.97846L9.37923 13.9069L7.29846 13.9077Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExcel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/excel.a9feadcf.svg";
export { ForwardRef as ReactComponent };